<template>
  <div id="percent-bar">
    <div
      id="percent-complete"
      :style="{width: getPercentComplete(amountCompleted) + '%'}"
    />
  </div>
</template>

<script>
export default {
  name: 'PercentBar',
  props: {
    amountCompleted: {
      type: Number,
      required: true
    }
  },
  methods: {
    getPercentComplete (value) {
      switch (value) {
        case 1:
          return 15;
        case 2:
          return 20;
        case 3:
          return 30;
        case 4:
          return 40;
        case 5:
          return 50;
        case 6:
          return 60;
        case 7:
          return 70;
        case 8:
          return 80;
        case 9:
          return 90;
        case 10:
          return 100;
        default:
          return 100;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#percent-bar {
  width: 100%;
  height: 1rem;
  background-color: $grey-lighter;
  border-radius: 100px;
}

#percent-complete {
  display: block;
  content: "\200B"; // Needs an empty character in order to take height/width attributes.
  height: 1rem;
  background-color: $primary;
  border-radius: 100px;
}
</style>
